import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";

//And then importing them in other files:
import { demo } from "../../assets/demo";
import { cropped } from "../../assets/cropped";
import { device } from "../../assets/device";
import { HttpClient } from "@angular/common/http";
import { NetworkProvider } from "../network/network";
import { AlertController } from "ionic-angular";

/*
  Generated class for the StorageProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class StorageProvider {
  screenshots: any;

  constructor(
    private storage: Storage,
    private networkProvider: NetworkProvider,
    private alertCtrl: AlertController,
    private http: HttpClient
  ) {
    // console.log('Hello ProjecstProvider Provider');
    this.screenshots = [];
  }

  /**
   * Méthode GET classique
   *
   * @param {string} url url de la requete
   * @param {object} params parametres de la requete
   * @param {object} headers headers de la requete
   */
  get(url, params = null, headers = null) {
    console.log("get ", url);
    return new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          console.log("get " + url + " data : ",data);
          resolve(data);
        },
        err => {
          console.log("get " + url + " error : ",err);
          reject(err);
        }
      );
    });
  }

  getDemo() {
    return demo;
  }

  async updateMockups(type, data) {
    return await this.storage
      .set(type, data)
      .then(storageData => {
        console.log("updateMockups", storageData);
        return true;
      })
      .catch(err => {
        console.log(err);
        return false;
      });
  }

  async getMockups(type) {
    if(type == 'cropped')
      return cropped;
    if(type == 'device')
      return device;
    if(type == 'demo')
      return demo;
    console.log("getMockups");
    let data;
    try {
      if (this.networkProvider.isConnected()) {
        console.log("isConnected");
        data = await this.get(
          "http://www.mooockups.julienkermarec.com/" + type + ".json"
        );
        return data;
      } else {
        console.log("not connected");
        data = await this.getMockupsStorage(type);
        if (data.length == 0) {
          this.presentAlert("Erreur", "Impossible de synchroniser les mockups hors connexion");
          return [];
        }
        else
          return data;
      }
    } catch (error) {
      this.presentAlert("Erreur", "Impossible de synchroniser les mockups");
      return [];
    }
  }

  getDevice() {
    return device;
  }

  async getMockupsStorage(type) {
    return await this.storage
      .get(type)
      .then(async storageData => {
        console.log("storageData : ", type);
        console.log(storageData);
        if (storageData != null) {
          await this.updateMockups(type, storageData);
          return this.screenshots;
        } else return [];
      })
      .catch(err => {
        console.log("err");
        console.log(err);
        return [];
      });
  }
  async getScreenshots() {
    return await this.storage
      .get("screenshots")
      .then(storageData => {
        // console.log("storageData");
        // console.log(storageData);
        if (storageData != null) this.screenshots = storageData;
        else this.screenshots = [];
        console.log("this.screenshots", this.screenshots);
        return this.screenshots;
      })
      .catch(err => {
        console.log("err");
        console.log(err);
      });
  }

  getProjectIndex(project_id) {
    let i = 0;
    for (let project of this.screenshots) {
      if (project.id == project_id) return i;
      i++;
    }
  }

  async addScreenshot(screenshot) {
    console.log("addScreenshot(screenshot,screenshot_index)");
    console.log("screenshots", screenshot);

    if (!screenshot["id"]) {
      // ADD
      screenshot["id"] =
        new Date().getTime().toString() +
        (Math.floor(Math.random() * 1000) + 1).toString();
      this.screenshots.push(screenshot);
    } else {
      //UPDATE
      let screenshot_index = this.screenshots.findIndex(elem => {
        return elem.id == screenshot.id;
      });
      this.screenshots[screenshot_index] = screenshot;
    }

    return await this.storage
      .set("screenshots", this.screenshots)
      .then(storageData => {
        // console.log("addScreenshot",this.screenshots);
        return this.screenshots;
      })
      .catch(err => {
        console.log(err);
        return false;
      });
  }

  async updateScreenshots(screenshots) {
    // let found = this.screenshots.findIndex((elem) => {
    //   return elem.id == project.id;
    // });
    // console.log("updateScreenshots [" + found + "]", project);
    this.screenshots = screenshots;
    return await this.updateStorage();
  }

  async deleteProject(project) {
    let found = this.screenshots.findIndex(elem => {
      return elem.id == project.id;
    });

    this.screenshots.splice(found, 1);
    return await this.updateStorage();
  }

  async updateStorage() {
    return await this.storage
      .set("screenshots", this.screenshots)
      .then(storageData => {
        // console.log("addProject",this.screenshots);
        return this.screenshots;
      })
      .catch(err => {
        console.log(err);
        return false;
      });
  }

  /**
   * Affichage d'un message d'erreur en cas d'erreur 500;
   */
  presentAlert(title, text) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: text,
      buttons: ["OK"]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/storage/storage.ts